import { render, staticRenderFns } from "./NiroDisclosure2024.vue?vue&type=template&id=d5ccb6b6&"
import script from "./NiroDisclosure2024.vue?vue&type=script&lang=js&"
export * from "./NiroDisclosure2024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports